(function () {
  if (window.EBLuxuryCartV2Initialised) {
    return;
  }

  window.EBLuxuryCartV2Initialised = true;

  var savingTimers = new Map();
  var saveQueue = Promise.resolve();
  var checkoutInProgress = false;

  function getCartRoot() {
    if (
      window.Shopify &&
      Shopify.routes &&
      Shopify.routes.root
    ) {
      return Shopify.routes.root;
    }

    return '/';
  }

  function setStatus(line, message) {
    var status = line.querySelector(
      '[data-eb-line-status]'
    );

    if (status) {
      status.textContent = message;
    }
  }

  function readStoredProperties(line) {
    var parsedProperties;

    try {
      parsedProperties = JSON.parse(
        line.dataset.properties || '{}'
      );
    } catch (error) {
      return {};
    }

    /*
      Shopify Liquid can output line-item properties
      either as an object or as an array of property
      pairs. The Cart Ajax API always requires a
      key-value object.
    */

    if (Array.isArray(parsedProperties)) {
      return parsedProperties.reduce(
        function (properties, property) {
          if (
            Array.isArray(property) &&
            property.length >= 2
          ) {
            properties[property[0]] =
              property[1];

            return properties;
          }

          if (
            property &&
            typeof property === 'object'
          ) {
            if (
              Object.prototype.hasOwnProperty.call(
                property,
                'name'
              )
            ) {
              properties[property.name] =
                property.value;
            } else {
              Object.keys(property).forEach(
                function (propertyName) {
                  properties[propertyName] =
                    property[propertyName];
                }
              );
            }
          }

          return properties;
        },
        {}
      );
    }

    if (
      parsedProperties &&
      typeof parsedProperties === 'object'
    ) {
      return parsedProperties;
    }

    return {};
  }

    function collectProperties(line) {
    var properties = {};

    /*
      Rebuild Shopify's existing line-item properties
      explicitly as a key-value object.
    */

    var existingFields =
      line.querySelectorAll(
        '[data-eb-existing-property]'
      );

    existingFields.forEach(
      function (existingField) {
        var propertyName =
          existingField.dataset.propertyName;

        if (propertyName) {
          properties[propertyName] =
            existingField.value;
        }
      }
    );

    /*
      Add or replace the editable engraving and
      required-date values.
    */

    var editableFields =
      line.querySelectorAll(
        '[data-eb-line-property]'
      );

    editableFields.forEach(
      function (editableField) {
        var propertyName =
          editableField.dataset.ebLineProperty;

        if (propertyName) {
          properties[propertyName] =
            editableField.value;
        }
      }
    );

    return properties;
  }

  function readError(response) {
    return response
      .json()
      .catch(function () {
        return {};
      })
      .then(function (data) {
        throw new Error(
          data.description ||
          data.message ||
          'Unable to save cart information'
        );
      });
  }

  function updateLineProperties(
    line,
    additionalProperties
  ) {
    var properties = collectProperties(line);

    if (additionalProperties) {
      Object.keys(
        additionalProperties
      ).forEach(function (propertyName) {
        properties[propertyName] =
          additionalProperties[propertyName];
      });
    }

    setStatus(line, 'Saving…');

    return fetch(
      getCartRoot() + 'cart/change.js',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          line: Number(line.dataset.line),
          properties: properties
        })
      }
    )
      .then(function (response) {
        if (!response.ok) {
          return readError(response);
        }

        return response.json();
      })
      .then(function () {
        line.dataset.properties =
          JSON.stringify(properties);

        setStatus(line, 'Saved');

        window.setTimeout(function () {
          if (
            line.isConnected &&
            !checkoutInProgress
          ) {
            setStatus(line, '');
          }
        }, 1600);
      })
      .catch(function (error) {
        setStatus(
          line,
          error.message ||
          'Unable to save. Please try again.'
        );

        throw error;
      });
  }

  function saveCartNote(noteValue) {
    return fetch(
      getCartRoot() + 'cart/update.js',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          note: noteValue
        })
      }
    ).then(function (response) {
      if (!response.ok) {
        return readError(response);
      }

      return response.json();
    });
  }

  function addToQueue(task) {
    saveQueue = saveQueue
      .catch(function () {
        /*
          Allow later saves to continue even if an
          earlier request was unsuccessful.
        */
      })
      .then(task);

    return saveQueue;
  }

  function scheduleLineSave(field) {
    var existingTimer =
      savingTimers.get(field);

    if (existingTimer) {
      window.clearTimeout(existingTimer);
    }

    var newTimer = window.setTimeout(
      function () {
        savingTimers.delete(field);

        var line = field.closest(
          '[data-eb-cart-line]'
        );

        if (!line) {
          return;
        }

        addToQueue(function () {
          return updateLineProperties(line);
        });
      },
      700
    );

    savingTimers.set(field, newTimer);
  }

  function scheduleNoteSave(note) {
    var existingTimer =
      savingTimers.get(note);

    if (existingTimer) {
      window.clearTimeout(existingTimer);
    }

    var newTimer = window.setTimeout(
      function () {
        savingTimers.delete(note);

        addToQueue(function () {
          return saveCartNote(note.value);
        });
      },
      700
    );

    savingTimers.set(note, newTimer);
  }

  function clearSavingTimers() {
    savingTimers.forEach(
      function (timer) {
        window.clearTimeout(timer);
      }
    );

    savingTimers.clear();
  }

  function saveEverythingBeforeCheckout() {
    var lines = Array.from(
      document.querySelectorAll(
        '[data-eb-cart-line]'
      )
    );

    var note = document.getElementById(
      'Cart-note'
    );

    var noteValue = note
      ? note.value.trim()
      : '';

    var process = Promise.resolve();

    lines.forEach(function (line, index) {
      process = process.then(function () {
        var additionalProperties = null;

        if (index === 0) {
          additionalProperties = {
            'Order presentation note':
              noteValue
          };
        }

        return updateLineProperties(
          line,
          additionalProperties
        );
      });
    });

    process = process.then(function () {
      return saveCartNote(noteValue);
    });

    return process;
  }

  document.addEventListener(
    'input',
    function (event) {
      var propertyField =
        event.target.closest(
          '[data-eb-line-property]'
        );

      if (propertyField) {
        scheduleLineSave(propertyField);
        return;
      }

      if (event.target.id === 'Cart-note') {
        scheduleNoteSave(event.target);
      }
    }
  );

 
   document.addEventListener(
    'change',
    function (event) {
      var propertyField =
        event.target.closest(
          '[data-eb-line-property]'
        );

      var cartNote =
        event.target.id === 'Cart-note'
          ? event.target
          : null;

      /*
        Prevent Dawn's cart component from treating
        these custom fields as quantity changes.
      */
      if (propertyField || cartNote) {
        event.stopPropagation();
      }

      if (cartNote) {
        scheduleNoteSave(cartNote);
        return;
      }

      if (!propertyField) {
        return;
      }

      var existingTimer =
        savingTimers.get(propertyField);

      if (existingTimer) {
        window.clearTimeout(existingTimer);

        savingTimers.delete(
          propertyField
        );
      }

      var line = propertyField.closest(
        '[data-eb-cart-line]'
      );

      if (!line) {
        return;
      }

      addToQueue(function () {
        return updateLineProperties(line);
      });
    },
    true
  );
  
  document.addEventListener(
    'click',
    function (event) {
      var checkoutButton =
        event.target.closest('#checkout');

      if (!checkoutButton) {
        return;
      }

      event.preventDefault();

      if (checkoutInProgress) {
        return;
      }

      checkoutInProgress = true;
      clearSavingTimers();

      var originalText =
        checkoutButton.textContent;

      checkoutButton.disabled = true;
      checkoutButton.textContent =
        'Saving Your Details…';

      addToQueue(function () {
        return saveEverythingBeforeCheckout();
      })
        .then(function () {
          window.location.href =
            getCartRoot() + 'checkout';
        })
        .catch(function () {
          checkoutInProgress = false;
          checkoutButton.disabled = false;
          checkoutButton.textContent =
            originalText;

          var cartErrors =
            document.getElementById(
              'cart-errors'
            );

          if (cartErrors) {
            cartErrors.textContent =
              'We could not save your order details. Please check the information and try again.';
          }
        });
    }
  );
})();